import type { Serialised } from '@squaredup/ids';
import { groupBy } from 'lodash';
import { fiveMinutes } from 'queries/constants';
import { dashboardQueryKeys } from 'queries/queryKeys/dashboardKeys';
import { useQuery, useQueryClient } from 'react-query';
import { ListVariables, type VariableAndScope } from 'services/VariableService';

export const useWorkspaceVariables = (workspaceId: string | null | undefined, dashboardIds: string[] | undefined) => {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ['workspace', workspaceId, 'variables'],
        queryFn: async () => {
            const variables = await ListVariables(workspaceId!);
            const variablesByDashboardId = groupBy(variables, ({ variable }) => variable.data.dashId);

            dashboardIds!.forEach((dashboardId) => {
                queryClient.setQueryData<Serialised<VariableAndScope>[]>(
                    dashboardQueryKeys.variableData(dashboardId),
                    variablesByDashboardId[dashboardId] ?? []
                );
            });
        },
        staleTime: fiveMinutes,
        cacheTime: fiveMinutes,
        keepPreviousData: true,
        refetchInterval: fiveMinutes,
        enabled: workspaceId != null && dashboardIds != null && dashboardIds.length > 0
    });
};
